import RestResource from '@/services/rest/RestResource'
import config from '@/config/config'
import store from '@/store/store'

export default class TroodyApi extends RestResource {
    constructor (suffix = '') {
        super({
            basePath: `${config.troodyApiBase}${suffix}`,
            authToken: () => {
                const authToken = store.getters['oidcStore/oidcAccessToken']

                // If we don't have an auth token any more, time to re-authenticate
                if (!authToken) {
                    store.dispatch('oidcStore/authenticateOidc')
                }

                return authToken
            },
        })
    }
}
